import { Box, Spinner } from 'native-base';
export const FormDataIsLoading = () => (
  <Box h={400} justifyContent="center">
    <Spinner />
  </Box>
);
